/**
 * AuthWorks Web Components
 *
 * Registration entry point for all custom elements.
 * Import this file to register all aw-* components.
 */

import { AWButton } from './aw-button';
import { AWToggle } from './aw-toggle';
import { AWToast, showToast } from './aw-toast';

// Register all components
const components: [string, CustomElementConstructor][] = [
  ['aw-button', AWButton],
  ['aw-toggle', AWToggle],
  ['aw-toast', AWToast],
];

// Register only if not already defined (allows multiple imports)
for (const [name, constructor] of components) {
  if (!customElements.get(name)) {
    customElements.define(name, constructor);
  }
}

// Export components for external use
export { AWButton };
export { AWToggle };
export { AWToast, showToast };
export { AWElement } from './base';
